@if (placeholder) {
  <ng-content></ng-content>
}

@if (!placeholder) {
  <div [innerHTML]="value"></div>
}
